import { useState } from "react";
import {
  Answer,
  Container,
  GridContainer,
  QnaSection,
  Question,
} from "./ContentBlock.style";

type QnABlockData = {
  heading: string;
  description: string;
};

type ContentBlockProps = {
  data?: QnABlockData[];
};

const ContentBlock = ({ data }: ContentBlockProps) => {
  const qnaData = data || []; // || LOCAL_CONTENT_BLOCK_INFO;
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());

  const toggleExpand = (index: number) => {
    setExpandedItems((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  return (
    <Container>
      <GridContainer>
        {qnaData?.map((item, index) => {
          const isExpanded = expandedItems.has(index);
          return (
            <QnaSection key={index} index={index}>
              <Question>{item?.heading}</Question>
              <Answer
                isExpanded={isExpanded}
                onClick={() => toggleExpand(index)}
                dangerouslySetInnerHTML={{ __html: item?.description || "" }}
              />
            </QnaSection>
          );
        })}
      </GridContainer>
    </Container>
  );
};

export default ContentBlock;
